import React from "react";

import { TeleopListData } from "./TeleopListData";

export interface ITeleopListProps {
    onClose: () => void;
}
const TeleopListIndex = (props: ITeleopListProps) => (
    <TeleopListData onClose={props.onClose} />
);

export default TeleopListIndex;
